module.exports = __webpack_public_path__ + "static/media/Telefonoanalogo.6d5c3c9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/Telefonoanalogo.svg
// module id = 387
// module chunks = 16